import React from "react"
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";

function TitleText(props) {
    return (
        <span>
            INFORMACE PRO UCHAZEČE O ZAMĚSTNÁNÍ A PRO ZAMĚSTNANCE O ZPRACOVÁNÍ OSOBNÍCH ÚDAJŮ<br/>
            ve vztahu k aplikaci Onboarding
        </span>
    );
}

function BodyText(props) {
    return (
        <div>
            <p className='font-weight-bold'>podle zákona č. 110/2019 Sb., o zpracování osobních údajů, ve znění pozdějších předpisů a Nařízení Evropského parlamentu a Rady (EU) 2016/679 ze dne 27. 4. 2016 o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES.</p>
            <hr/>
            <p>Na níže odkazovaných webových stránkách bychom Vás rádi informovali o zásadách a postupech při zpracování Vašich osobních údajů a o Vašich právech, a to v souladu s ustanoveními zákona č. 110/2019 Sb., o zpracování osobních údajů, ve znění pozdějších předpisů (dále jen "Zákon"), Nařízením Evropského parlamentu a Rady (EU) 2016/679 ze dne 27. 4. 2016 o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES (dále jen "Nařízení"), a zákona č. 480/2004 Sb., o některých službách informační společnosti, ve znění pozdějších předpisů.</p>
            <p>Společnosti GasNet, s.r.o., se sídlem Klíšská 940/96, Klíše, 400 01 Ústí nad Labem, IČ 27295567, zapsána v obchodním rejstříku Krajského soudu v Ústí nad Labem, sp. zn. C 23083 (dále též "GsN") a společnost GridServices, s.r.o., se sídlem Plynárenská 499/1, Zábrdovice, 602 00 Brno, IČ 27935311, zapsána v obchodním rejstříku Krajského soudu v Brně, sp. zn. C 57165 (dále též "GridS"), jsou ve smyslu ustanovení článku 26 Nařízení společní správci osobních údajů subjektu údajů, kdy tímto dokumentem plní povinnost ve smyslu ustanovení článku 13 a 14 Nařízení, a to poskytnout transparentním způsobem subjektu údajů informace o zpracování osobních údajů ve vztahu k aplikaci Onboarding, která je využívána jako digitální průvodce, který vybraného uchazeče a následně nového zaměstnance provádí interními HR procesy od okamžiku přijetí pracovní nabídky až po dobu prvních šesti měsíců jeho působení na novém pracovišti.</p>
            <p>Ucelené informace o zpracování osobních údajů vyžadované platnými právními předpisy, včetně jejich rozsahu a účelu zpracování, přehledu práv a povinností GsN a GridS, a aktualizovaného seznamu zpracovatelů a příjemců osobních údajů, jsou dostupné:</p>
            <ul>
                <li><strong>pro subjekt údajů v roli uchazeče o zaměstnání</strong> na webových stránkách GsN pod odkazem: (<a href='https://www.gasnet.cz/-/media/GasNet/Files/Gasnet/gdpr/IM_pro_uchazece_GRID_HR.pdf' target='_blank'>https://www.gasnet.cz/-/media/GasNet/Files/Gasnet/gdpr/IM_pro_uchazece_GRID_HR.pdf</a>) a kdykoli v průběhu využívání aplikace Onboarding budou subjektu údajů poskytnuty na jeho vyžádání, adresované písemně na adresu sídla GsN a/nebo GridS;</li>
                <li><strong>pro subjekt údajů v roli zaměstnance GsN nebo GridS</strong> na intranetu zaměstnavatele v sekci Bezpečnost a OŽP → Bezpečnost a Security → Ochrana osobních údajů a ochrana dat a kdykoli na zaměstnancovo vyžádání budou Pověřencem pro ochranu osobních údajů poskytnuty v tištěné podobě.</li>
            </ul>
            <p className='font-italic'>Tyto zásady mají informativní a právně normativní charakter, nejsou součástí pracovní ani jiné smlouvy. Tento dokument je účinný dnem zveřejnění 09. 03. 2020. Poslední aktualizace textu proběhla 01. 05. 2020.</p>
        </div>
    )
}

class PrivacyPolicy extends React.Component {
    render() {
        const {open, toggle, asPage} = this.props;

        if (asPage) {
            return (
                <div className="main-content-menuless bg-gray">
                    <div className='container pt-3 mb-3'>
                        <div className='card bg-white'>
                            <div className='card-body'>
                                <h1><TitleText/></h1>
                                <hr/>
                                <BodyText/>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <Modal size='lg' isOpen={open} toggle={toggle} className={''}>
                    <ModalHeader toggle={toggle}><TitleText/></ModalHeader>
                    <ModalBody>
                        <BodyText/>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}><FormattedMessage id='app.gdpr.close'/></Button>
                    </ModalFooter>
                </Modal>
            )
        }
    };
}

export default PrivacyPolicy;
